import App from '@modules/husleie-framework/src/static-classes/App.class';

export default class LogOperations {
  static error(module: string, ...args: any[]): void {
    // eslint-disable-next-line no-console
    console.debug(`%c[${App.getName()}|${module}]`, 'font-weight: bold;color: red', ...args);
  }

  static warning(module: string, ...args: any[]): void {
    // eslint-disable-next-line no-console
    console.debug(`%c[${App.getName()}|${module}]`, 'font-weight: bold;color: orange', ...args);
  }

  static debug(module: string, ...args: any[]): void {
    // eslint-disable-next-line no-console
    console.debug(`%c[${App.getName()}|${module}]`, 'font-weight: bold;', ...args);
  }
}
